import { ImageElementStyle, imageRatioCalculationMap, Ratio } from '../ImageElement.types';

import { isRatioObject } from './IsRatioObject';

export const createImageStyleWithRatio = (ratio: Ratio): ImageElementStyle => {
  if (isRatioObject(ratio)) {
    return {
      '--ratio-mobile': imageRatioCalculationMap[ratio.mobile],
      '--ratio-tablet': imageRatioCalculationMap[ratio.tablet],
      '--ratio-desktop': imageRatioCalculationMap[ratio.desktop],
    };
  }
  return {
    '--ratio-mobile': imageRatioCalculationMap[ratio],
    '--ratio-tablet': imageRatioCalculationMap[ratio],
    '--ratio-desktop': imageRatioCalculationMap[ratio],
  };
};
